import { render, staticRenderFns } from "./TukarPoin.vue?vue&type=template&id=75705a1a&scoped=true"
import script from "./TukarPoin.vue?vue&type=script&lang=js"
export * from "./TukarPoin.vue?vue&type=script&lang=js"
import style0 from "./TukarPoin.vue?vue&type=style&index=0&id=75705a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75705a1a",
  null
  
)

export default component.exports